import React, { useEffect, useRef, useMemo } from "react";

const SpinningWheel = ({rewards, prize, onDone})=> {

  const wheelRef       = useRef();
  const rotationValues = useMemo(()=> rewards.map((el, index)=> (
    {
      minDegree: index ? index * (360 / rewards.length) + 1 : 0,
      maxDegree: (index + 1) * (360 / rewards.length),
      value: el,
    }
  )));

  const colors   = ['#01b78f', '#00376f', '#f94b26', '#f8b214'];
  let clipRatio  = {
    4  : 2   ,
    5  : 18  ,
    6  : 29  ,
    7  : 38  ,
    8  : 44  ,
    9  : 49  ,
    10 : 54  ,
    11 : 57  ,
    12 : 60  ,
    13 : 63  ,
    14 : 65  ,
    15 : 67  ,
    16 : 69  ,
  };

  useEffect(()=> {

    if(!prize) return;

    const minSpins     = 3;
    const spinningTime = 3000;

    const winnerValue = rotationValues.find((el)=> el.value === prize);
    const spins       = minSpins * 360 + ((Math.floor(Math.random() * 4) + 1) * 360) + (winnerValue.minDegree + winnerValue.maxDegree) / 2;

    wheelRef.current.style.transitionDuration = `${spinningTime}ms`;
    wheelRef.current.style.transform          = `rotate(${-spins}deg)`;

    setTimeout(()=> {
      wheelRef.current.style.transitionDuration = '0ms';
      wheelRef.current.style.transform = `rotate(-${(winnerValue.minDegree + winnerValue.maxDegree) / 2}deg)`;
      onDone(prize);
    }, spinningTime + 100);
  }, [prize]);

  return (
    <div>
      <div className='spinning-wheel-container'>
        <div className='wheel' ref={wheelRef} style={{
          transform : `rotate(-${((rotationValues[0]?.minDegree || 0) + (rotationValues[0]?.maxDegree ||0)) / 2}deg`
        }}>
          { rewards.map((reward,index)=>
            <div className="prize" key={reward} style={{
              backgroundColor : colors[index % colors.length],
              transform       : `rotate(${360 / rewards.length * index}deg)`,
              clipPath        : `polygon(${clipRatio[rewards.length] || 0}% 0, 100% 0, 100% ${100 - clipRatio[rewards.length] || 0}%, 0 100%)`
            }}> <span> {reward} </span> </div>
          ) }
        </div>
      </div>
    </div>
  );

}

export default SpinningWheel;
